/**
 *
 * OverallTrendsAnonymous
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import { useDispatch } from 'react-redux';
import { format } from 'date-fns';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { moveAnonymousAssessments } from 'containers/Assessment/actions';
import ButtonBase from '@material-ui/core/ButtonBase';
import useSiteCopySelector from 'components/useSiteCopySelector';
import Mixpanel from 'utils/mixpanelService';
import Trends from './TrendsChart';
import { getCurrentInterval } from '../../utils';

const useStyles = makeStyles(theme => ({
  container: {
    position: 'relative',
  },
  callToActionButton: {
    position: 'absolute',
    width: '65%',
    top: '50%',
    left: '50%',
    transform: 'translateY(-50%) translateX(-50%)',
    display: 'flex',
    padding: '4px 24px',
    borderRadius: 13,
    color: 'white',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    ...theme.typography.caption,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 1)',
    },
  },
}));

function OverallTrendsAnonymous({
  assessment,
  component,
  scale,
  sortedIntervals,
  displayIntervals,
}) {
  const [assessmentResultsSiteCopy] = useSiteCopySelector([
    'assessment-results',
  ]);
  const classes = useStyles();
  const dispatch = useDispatch();

  if (!component.overallScoring) return null;

  const handleCallToActionClick = () => {
    Mixpanel.track('Assessment Results Trend - Sign Up CTA Clicked', {
      assessment: _get(assessment, 'fields.name'),
      entryId: assessment.sys.id,
    });

    dispatch(moveAnonymousAssessments());
  };

  const { overallScoring, valueDirection, maxValue, minValue } = component;
  let score;
  if (valueDirection === 'higherBetter') {
    score = Math.round((overallScoring / (maxValue - minValue)) * 100);
  } else {
    score = Math.round(
      ((maxValue - minValue - overallScoring) / maxValue) * 100,
    );
  }

  return (
    <Grid item xs={12} md="auto" className={classes.wrapper}>
      <Typography variant="h6" color="textPrimary" className={classes.header}>
        {_get(assessmentResultsSiteCopy, 'pageCopy.trendsHeader')}
      </Typography>
      <Box component="div" className={classes.container}>
        <Trends
          scale={scale}
          blurred
          sortedIntervals={sortedIntervals}
          values={[
            {
              score: Math.round(component.overallScoring),
              date: format(Date.now(), 'MMM-dd-yy'),
              timestamp: Date.now(),
              color: _get(
                getCurrentInterval(displayIntervals, score),
                '0.color',
                '#01619B',
              ),
            },
          ]}
        />
        <ButtonBase
          className={classes.callToActionButton}
          disableRipple
          onClick={handleCallToActionClick}
        >
          {_get(
            assessmentResultsSiteCopy,
            'pageCopy.trendsUnsignedCallToAction',
          )}
        </ButtonBase>
      </Box>
    </Grid>
  );
}

OverallTrendsAnonymous.propTypes = {
  assessment: PropTypes.object,
  component: PropTypes.object,
  scale: PropTypes.number,
  sortedIntervals: PropTypes.array,
};

export default OverallTrendsAnonymous;
